module.exports = __webpack_public_path__ + "static/media/file-icon.55a942e9.jpg";